import {AbstractDictModel} from './abstract-dict.model';

export interface DistrTaskByProjectModel extends AbstractDictModel {
  userId: number;
  userName: string;
  distributionStatus: number;
  distributedCount: number;
  servicesCount: number;
}
